<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="人均劳务费:">
                <el-input size="mini" v-model="dataForm.perCapitaLaborCosts" placeholder="人均劳务费" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="折旧年数:">
                <el-input size="mini" v-model="dataForm.yearsOfDepreciation" placeholder="折旧年数" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
                <!-- <el-button size="mini" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border bProject style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="manufacturingProcess" header-align="center" width="200" align="left" label="制造工序名称">
                </el-table-column>
                <el-table-column prop="roundNo" header-align="center" align="right" width="110" label="第几轮报价">
                </el-table-column>
                <el-table-column prop="theNumberOfDirect" header-align="center" width="100" align="right" label="直接人数(A)">
                </el-table-column>
                <el-table-column prop="perCapitaLaborCosts" header-align="center" align="right" width="160" label="人均劳务费(元/小时)(B)">
                    <template slot-scope="scope">
                        {{scope.row.perCapitaLaborCosts}}
                    </template>
                </el-table-column>
                <el-table-column prop="personnelProportion" header-align="center" align="right" width="160" label="间接制造人员比例%(C)">
                </el-table-column>
                <el-table-column prop="labor" header-align="center" align="right" width="230" label="每小时劳务费(元/小时)D=A*B*(1+C)">
                    <template slot-scope="scope">
                        {{scope.row.labor}}
                    </template>
                </el-table-column>
                <el-table-column prop="investment" header-align="center" align="right" width="100" label="投资额(E)">
                    <template slot-scope="scope">
                        {{scope.row.investment}}
                    </template>
                </el-table-column>
                <el-table-column prop="yearsOfDepreciation" header-align="center" align="right" width="100" label="折旧年数(F)">
                </el-table-column>
                <el-table-column prop="annualStartTime" header-align="center" align="right" width="170" label="每年开工时间(小时/年)(G)">
                </el-table-column>
                <el-table-column prop="depreciationPerHour" header-align="center" align="right" width="220" label="每小时折旧费(元/小时) H=E/(F*G)">
                    <template slot-scope="scope">
                        {{scope.row.depreciationPerHour}}
                    </template>
                </el-table-column>
                <el-table-column prop="auxiliaryMaterials" header-align="center" align="right" width="210" label="公用动力辅助材料等(元/小时) (I)">
                    <template slot-scope="scope">
                        {{scope.row.auxiliaryMaterials}}
                    </template>
                </el-table-column>
                <el-table-column prop="summation" header-align="center" align="right" width="160" label="合计(元/小时) J=D+H+I">
                    <template slot-scope="scope">
                        {{scope.row.summation}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" width="100" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <!--<el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchRfqQuotationConversion,
    removeRfqQuotationConversion
} from '@/controller/quotation'
import AddOrUpdate from './quotationConversion-add-or-update'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                roundNo: '',
                perCapitaLaborCosts: '',
                investment: ''
            },
            viewFlag: '',
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270
            }
        }
    },
    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchRfqQuotationConversion({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm)
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeRfqQuotationConversion({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss">
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
